import store from '@state/store'
import getSecret from '@utils/get-secret'
import routesred from './routesred'

const host = window.location.host;
const parts = host.split(/[:.]+/);
let redColaborativaDomain = getSecret('RED_COLABORATIVA')

var routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@views/home/index'),
    meta: {
      authRequired: true,

    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  // Administration section
  {
    path: '/management/users/',
    name: 'users',
    component: () => import('@views/management/users/index'),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/management/groups/',
    name: 'groups',
    component: () => import('@views/management/groups/index'),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/management/perms/',
    name: 'perms',
    component: () => import('@views/management/perms/index'),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/management/app-sections/',
    name: 'app-sections',
    component: () => import('@views/management/app-sections/index'),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/management/company-info/',
    name: 'company-info',
    component: () => import('@views/management/company-info/index'),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/management/security/',
    name: 'security',
    component: () => import('@views/management/security/index'),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/management/masters/',
    name: 'masters',
    component: () => lazyLoadView(import('@views/management/masters/index')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/management/content-creators/',
    name: 'content-creators',
    component: () => lazyLoadView(import('@views/management/content-creators/index')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),

  },

  // Others
  {
    path: '/login',
    name: 'login',
    component: () => import('@views/login'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'home' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      authRequired: false,
      beforeResolve(routeTo, routeFrom, next) {
        store.dispatch('auth/logOut')
        const authRequiredOnPreviousRoute = routeFrom.matched.some(
          (route) => route.meta.authRequired
        )
        // Navigate back to previous page, or home as a fallback
        next(authRequiredOnPreviousRoute ? {
          name: 'login', params: routeTo.params ? routeTo.params : {}
        } : { ...routeFrom })
      },
    },
  },
  {
    path: '/forget-password',
    name: 'forget-password',
    component: () => lazyLoadView(import('@views/forgetPassword')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'home' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/reset-password/:uuid/',
    name: 'reset-password',
    component: () => lazyLoadView(import('@views/resetPassword')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'home' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  // Scheduled tasks
  {
    path: '/scheduled_tasks/periodic_task/',
    name: 'periodic_tasks',
    component: () => lazyLoadView(import('@views/scheduled_tasks/periodic_tasks/index')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/scheduled_tasks/task_result/',
    name: 'periodic_tasks_results',
    component: () => lazyLoadView(import('@views/scheduled_tasks/tasks_results/index')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },

  // TAC
  // projects:
  {
    path: '/projects/requests/',
    name: 'projects_requests',
    component: () => lazyLoadView(import('@views/projects/requests/index')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/projects/requests_management/',
    name: 'requests_management',
    component: () => lazyLoadView(import('@views/projects/requests_management/index')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/reports/',
    name: 'reports_participants',
    component: () => lazyLoadView(import('@views/reports/index.vue')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/content/',
    name: 'content',
    component: () => lazyLoadView(import('@views/content/index')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),

  },

  // 404
  {
    path: '/404',
    name: '404',
    component: require('@views/_404').default,
    // Allows props to be passed to the 404 page through route
    // params, such as `resource` to define what wasn't found.
    props: true,
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    redirect: '404',
  },
]
if (parts[0] === redColaborativaDomain) {
  routes = routesred;
}
export default routes;

// Lazy-loads view components, but with better UX. A loading view
// will be used if the component takes a while to load, falling
// back to a timeout view in case the page fails to load. You can
// use this component to lazy-load a route with:
//
// component: () => lazyLoadView(import('@views/my-view'))
//
// NOTE: Components loaded with this strategy DO NOT have access
// to in-component guards, such as beforeRouteEnter,
// beforeRouteUpdate, and beforeRouteLeave. You must either use
// route-level guards instead or lazy-load the component directly:
//
// component: () => import('@views/my-view')
//
function lazyLoadView(AsyncView) {
  const AsyncHandler = () => ({
    component: AsyncView,
    // A component to use while the component is loading.
    loading: require('@views/_loading').default,
    // Delay before showing the loading component.
    // Default: 200 (milliseconds).
    delay: 200,
    // A fallback component in case the timeout is exceeded
    // when loading the component.
    error: require('@views/_timeout').default,
    // Time before giving up trying to load the component.
    // Default: Infinity (milliseconds).
    timeout: 10000,
  })

  return Promise.resolve({
    functional: true,
    render(h, { data, children }) {
      // Transparently pass any props or children
      // to the view component.
      return h(AsyncHandler, data, children)
    },
  })
}
